export default "__VITE_ASSET__8dcfb03d__"